import { useProcedureOptional, getStoredProcedureSlug } from './ProcedureContext';
import { getProcedureBasePath } from './procedureRoutes';

const SPAIN = {
  landing: '/es/regularizacion',
  qualify: '/es/regularizacion/qualify',
  qualifyQualified: '/es/regularizacion/qualify/qualified',
  signup: '/es/regularizacion/registro',
  success: '/es/regularizacion/success',
  isProcedure: false,
};

/** Navigation targets for Spain regularization vs multi-procedure routes. */
export function useApplicantFlowPaths() {
  const proc = useProcedureOptional();
  let basePath = proc?.basePath || null;
  let slug = proc?.slug || null;

  if (!basePath) {
    const stored = getStoredProcedureSlug();
    if (stored) {
      basePath = getProcedureBasePath(stored);
      slug = stored;
    }
  }

  if (basePath) {
    return {
      landing: basePath,
      qualify: `${basePath}/qualify`,
      qualifyQualified: `${basePath}/qualify/qualified`,
      signup: `${basePath}/registro`,
      success: `${basePath}/success`,
      isProcedure: Boolean(slug && slug !== 'es-regularizacion'),
      procedureSlug: slug,
    };
  }
  return SPAIN;
}
